export default "__VITE_ASSET__CYncdI5f__"